<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="cooperationProgress">
			<platformTab @change="pfHandleClick" :showAll="true" :platformId="platformId" />
			<search :sampleAudit="sampleAudit" :platformId="platformId" ref="search" @onSubmit="onSubmit"></search>
		</Panel>
		<Panel :contentPaddingTop="6">
			<div>
				<!--        :key重载解决tab下划线错位问题-->
				<el-tabs :key="showTab" v-model="tabName" @tab-click="handleClick">
					<el-tab-pane :name="item.name" :label="`${item.label}`" v-for="(item, index) in tableArr" :key="item.name"></el-tab-pane>
				</el-tabs>
				<sampleOrderStatistics :sampleObj="sampleObj" :tabName="tabName" v-loading="statisticsLoading"></sampleOrderStatistics>
				<div class="flex-column tab">
					<div class="table-box" v-loading="loading" element-loading-spinner="el-icon-loading">
						<div class="btn-box flex-align-center flex pos-rela">
							<button-group v-if="tabName === '1' || tabName === '10'">
								<div>
									<el-checkbox @change="checkeAll" v-model="allChecked">当页全选</el-checkbox>
								</div>
								<div class="ml-10" v-auth="['system:sampleOrder:remark']">
									<el-tooltip content="请选择商品" :disabled="!!selectionShopArr.length" placement="top">
										<el-button @click="batchContact">批量联系商家</el-button>
									</el-tooltip>
								</div>
							</button-group>
							<button-group v-if="$auth.hasPermi('system:sampleOrder:export')">
								<el-button @click="exprotTable">导出样品订单</el-button>
							</button-group>
							<button-group>
								<el-button @click="importFun()" v-if="tabName !== '11' && $auth.hasPermi('system:sampleOrder:deliver')">批量发货</el-button>
								<el-button @click="batchImport()" v-if="tabName === '0' && $auth.hasPermi('system:sampleOrder:import')">批量导入订单</el-button>
								<el-button @click="goToPage" v-if="tabName === '0' && $auth.hasPermi('system:sampleOrder:import')">导入记录</el-button>
								<el-button @click="batchRefuseFun(selectionShopArr)" v-if="tabName === '1' && $auth.hasPermi('system:sampleOrder:Refusal-delivery')">
									批量拒绝发货
								</el-button>
								<template v-if="tabName === '10' || tabName === '1'">
									<template v-if="tabName === '10'">
										<el-tooltip content="请选择商品" :disabled="!!selectionShopArr.length" placement="top">
											<el-button v-if="$auth.hasPermi('system:sample:merchant-audit')" @click="batchPass()">批量通过</el-button>
										</el-tooltip>
										<el-tooltip content="请选择商品" :disabled="!!selectionShopArr.length" placement="top">
											<el-button v-if="$auth.hasPermi('system:sample:merchant-audit')" @click="batchRefuse()">批量拒绝</el-button>
										</el-tooltip>
									</template>
									<template v-if="cooperationStatus && $isPlatOr(['Dy', 'Ks'])">
										<el-tooltip content="请选择商品" :disabled="!!selectionShopArr.length" placement="top">
											<el-button v-if="$auth.hasPermi('system:sample:merchant-collaboration')" @click="batchSyncCollaborate()">
												同步样品协作
											</el-button>
										</el-tooltip>
										<el-tooltip content="请选择商品" :disabled="!!selectionShopArr.length" placement="top">
											<el-button v-if="$auth.hasPermi('system:sample:merchant-collaboration')" @click="batchCancelCollaborate()">
												取消样品协作
											</el-button>
										</el-tooltip>
									</template>
								</template>
							</button-group>
							<button-group v-if="tabName === '1'">
								<el-checkbox @change="seeNotContact" v-model="notContact" class="mr-10">仅查看未联系商家</el-checkbox>
							</button-group>
							<div
								v-if="tabName === '4'"
								class="font-h6-regular flex-row-align-center cursor-pointer"
								:class="receiveTimeSort ? 'yx-color-primary' : ''"
								@click="sortByRecive"
							>
								到货时间
								<i :class="receiveTimeSort ? 'i-sort-down-active' : 'i-sort-down'"></i>
							</div>
							<div
								class="pos-abso bind-icon cursor-pointer"
								@click="bindShopSkip"
								v-if="$isPlatOr(['Dy', 'Ks']) && vuex_isshopurl && (isBoss || isSallerPatner)"
							>
								<img src="@/assets/public/bind-collaborate-icon.png" alt="" />
							</div>
						</div>
						<multi-table
							tabName="1"
							class="multiTable"
							ref="multiTable"
							:selectionChange="selectionChange"
							:columns="columns"
							@gePartnerList="gePartnerList"
							:list="list"
							:options="options"
							:total="total"
						></multi-table>
					</div>
				</div>
			</div>
		</Panel>

		<editProduct ref="editProduct" @refreshList="refreshList"></editProduct>
		<sendGood ref="sendGood" @refreshList="refreshList"></sendGood>
		<replaceLink ref="replaceLink" @refreshList="refreshList"></replaceLink>
		<cooperData ref="cooperData" @refreshList="refreshList"></cooperData>
		<refuse ref="refuse" @refreshList="refreshList"></refuse>
		<reason ref="reason" @refreshList="refreshList"></reason>
		<apply ref="apply" @refreshList="refreshList"></apply>
		<change ref="change" @refreshList="refreshList"></change>
		<multi ref="multi" @refreshList="refreshList"></multi>
		<begin ref="begin" @refreshList="refreshList"></begin>
		<exportData ref="exportData" @refreshList="refreshList"></exportData>

		<!-- 批量发货 -->
		<importDialog ref="importDialog" @refreshList="refreshList"></importDialog>
		<!--批量导入-->
		<batchImportDialog ref="batchImportDialog" @refreshList="refreshList"></batchImportDialog>
		<changeDetails ref="changeDetails" @refreshList="refreshList"></changeDetails>
		<handCardDialog ref="handCardDialog"></handCardDialog>
		<detail-drawer ref="detailDrawer" @getList="refreshList" />
		<logistics-detail-drawer ref="logisticsDetailDrawer" tabName="1" @getList="refreshList" />
		<batch ref="batch" @refreshList="refreshList"></batch>
		<remarks ref="remarks" @refreshList="refreshList"></remarks>

		<!-- 样品订单发货 -->
		<sampleSendGoods ref="sampleSendGoods" @refresh="refreshList" />

		<!-- 批量到货 -->
		<takeDialog ref="takeDialog" @getList="refreshList" />

		<!-- 拒绝申请 -->
		<refuse-apply ref="refuseApply" @refresh="refreshList" />

		<!-- 同步样品协作 -->
		<sync-collaborate ref="syncCollaborate" @refresh="refreshList" />

		<!--    批量拒绝发货-->
		<batch-refuse ref="batchRefuse" @refresh="refreshList"></batch-refuse>
		<shareDrawer ref="shareDrawer" :key="timer"></shareDrawer>
		<!-- 导出样品订单 -->
		<exportSampleOrderDrawer ref="exportSampleOrderDrawer"></exportSampleOrderDrawer>
	</div>
</template>
<script>
import throttle from 'lodash/throttle';
import mixin from './mixin';
import { columns } from './columns';
import { getButtons } from './buttons';
import search from './components/search.vue';
import { mapGetters, mapState } from 'vuex';
import editProduct from '@/views/cooperationProgress/list/components/dialog/editProduct.vue';
import sendGood from '@/views/cooperationProgress/list/components/dialog/sendGood.vue';
import replaceLink from '@/views/cooperationProgress/list/components/dialog/replaceLink.vue';
import cooperData from '@/views/cooperationProgress/list/components/dialog/cooperData.vue';
import refuse from './components/refuse.vue';
import reason from '@/views/cooperationProgress/list/components/dialog/reason.vue';
import apply from '@/views/cooperationProgress/list/components/dialog/apply.vue';
import change from '@/views/cooperationProgress/list/components/dialog/change.vue';
import multi from '@/views/cooperationProgress/list/components/dialog/multi.vue';
import begin from '@/views/cooperationProgress/list/components/dialog/begin.vue';
import exportData from '@/views/cooperationProgress/list/components/dialog/export.vue';
import importDialog from './components/import.vue';
import changeDetails from '@/views/cooperationProgress/list/components/dialog/changeDetails.vue';
import detailDrawer from '@/views/talentCRM/components/detailDrawer';
import logisticsDetailDrawer from './components/logisticsDetailDrawer';
import batchRefuse from './components/batchRefuse';
import batchImportDialog from './components/batchImport';
import { partnerList, stopCooperation, reCooperation } from '@/api/cooperationProgress';
import { shopCooperationStatus } from '@/api/cooperativeShop';
import shareDrawer from '@/views/common/dialog/shareDrawer.vue';
import exportSampleOrderDrawer from './components/exportSampleOrderDrawer/index.vue';
import {
	sampleList,
	sampleStatistical,
	// sampleStatusNum,
	exportSampleList,
	getAuditConf,
	batchsampleAuditPass,
	batchCancelCooperate,
	sampleStatisticalAll,
} from '@/api/sampleOrder';
import handCardDialog from '@/views/shopManage/components/handCardDialog.vue';
import { drRoleType, AUDIT_STATUS_OPEN, AUDIT_STATUS_CLOSE, sampleStutas } from '@/utils/dataMap';
import batch from './components/batch.vue';
import remarks from './components/remarks.vue';
import ButtonGroup from '@/components/ui/buttonGroup';
import sampleSendGoods from './components/sampleSendGoods';
import takeDialog from './components/takeDialog.vue';
import refuseApply from './components/refuseApply.vue';
import syncCollaborate from './components/syncCollaborate.vue';
import sampleOrderStatistics from './components/sampleOrderStatistics.vue';
import { platformMixin } from '@rd/rd-ui';
import { calDate } from '@/utils/common';
import { subMonths, startOfDay } from 'date-fns';
export default {
	name: 'cooperationProgress',
	components: {
		editProduct,
		search,
		sendGood,
		replaceLink,
		cooperData,
		refuse,
		apply,
		change,
		multi,
		begin,
		importDialog,
		changeDetails,
		handCardDialog,
		exportData,
		reason,
		detailDrawer,
		logisticsDetailDrawer,
		batch,
		remarks,
		ButtonGroup,
		sampleSendGoods,
		takeDialog,
		refuseApply,
		syncCollaborate,
		batchRefuse,
		batchImportDialog,
		sampleOrderStatistics,
		shareDrawer,
		exportSampleOrderDrawer,
	},
	mixins: [mixin, platformMixin],
	provide() {
		return {
			injectIsSampleOrder: () => this.sampleOrder,
			injectCooperationStatus: () => this.cooperationStatus,
		};
	},
	data() {
		return {
			timer: '',
			receiveTimeSort: false,
			columns,
			isSampleTable: true,
			tabName: '0',
			options: { selectable: false },
			list: [],
			selectionShopArr: [],
			params: {
				page_index: 1,
				page_size: 10,
				receiveTimeSort: undefined,
			},
			total: '0',
			allChecked: false,
			loading: false,
			homeStatArr: [],
			delivery_status: '',
			other_status: '',
			sampleObj: {},
			sampleStatusObj: {},
			notContact: false,
			exportLoading: false,
			// PlaybackRate: 0,
			sampleOrder: true,
			sampleAudit: AUDIT_STATUS_CLOSE,
			cooperationStatus: false,
			statisticsLoading: false,
			showTab: 0,
			platformId: '',
			// 在混入中被使用，更改默认的平台id
			defaultAllPlatformId: dataMap.PLATFORM_ALL.value,
			paramsTextObj: {},
		};
	},
	computed: {
		...mapGetters(['isBoss', 'isSallerPatner', 'isDarenPartner']),
		...mapState(['vuex_isshopurl']),
		cooperateId() {
			return (this.$route.query && this.$route.query.cooperate_id) || '';
		},
		deliveryStatus() {
			return (this.$route.query && this.$route.query.delivery_status) || '';
		},
		tableArr({ sampleAudit }) {
			let arr = [
				{ label: '全部', name: '0', isShow: true, key: 'all' },
				{ label: '待审核', name: '10', isShow: sampleAudit === AUDIT_STATUS_OPEN, key: 'wait_audit' },
				{ label: '待发货', name: '1', isShow: true, key: 'wait_deliver' },
				{ label: '已发货', name: '2', isShow: true, key: 'delivered' },
				{ label: '运输中', name: '3', isShow: true, key: 'transport' },
				{ label: '已到货', name: '4', isShow: true, key: 'arrival' },
				{ label: '确认带货', name: '5', isShow: true, key: 'confirm_selling' },
				{ label: '审核不通过', name: '11', isShow: sampleAudit === AUDIT_STATUS_OPEN, key: 'fail_audit' },
				{ label: '拒绝发货', name: '6', isShow: true, key: 'reject_deliver' },
				{ label: '拒绝带货', name: '7', isShow: true, key: 'reject_selling' },
				{ label: '已关闭', name: '8', isShow: true, key: 'closed' },
			];
			return arr.filter(item => item.isShow);
		},
	},
	created() {
		const { cooperateId, deliveryStatus } = this;
		if (cooperateId) this.params.cooperate_id = cooperateId;
		if (deliveryStatus) this.tabName = deliveryStatus;
		if (cooperateId || deliveryStatus) {
			this.getProductList();
			this.sampleStatistical();
			this.sampleStatusNum();
		}
		this.getAudit();
		this.getCooperationStatus();
	},
	mounted() {
		const { deliveryStatus } = this;
		if (deliveryStatus) this.$refs.search.setParams(this.tabName);
	},
	methods: {
		sortByRecive() {
			this.receiveTimeSort = !this.receiveTimeSort;
			this.params.receiveTimeSort = this.receiveTimeSort ? 1 : undefined;
			this.getProductList();
		},
		pfHandleClick(val) {
			this.platformId = val;
			this.$refs.search.onClear('', 'defaultTime');
		},
		//获取列表数据
		async getProductList() {
			this.loading = true;
			this.params.other_status = this.tabName;
			try {
				const { code, data } = await sampleList({ ...this.params, platform_id: this.platformId });
				if (code == 0) {
					this.list = data.list.map(item => {
						return {
							...item,
							operations: getButtons(this, item),
							openShareDrawerEvent: row => {
								this.timer = new Date().getTime();
								this.$nextTick(() => {
									this.$refs.shareDrawer.show(row);
								});
							},
						};
					});
				}
				this.loading = false;
			} catch (e) {
				this.loading = false;
			}
		},
		async sampleStatistical() {
			this.statisticsLoading = true;
			try {
				const { code, data = {} } =
					this.tabName === '0'
						? await sampleStatisticalAll({ ...this.params, platform_id: this.platformId })
						: await sampleStatistical({ ...this.params, platform_id: this.platformId });
				if (code === 0) {
					this.sampleObj = data;
					this.total = data.order_num;
				}
			} catch (error) {
				console.log(error);
			} finally {
				this.statisticsLoading = false;
			}
		},
		handleClick() {
			this.$set(this.options, 'selectable', this.tabName == '1' || this.tabName == '10');
			this.$refs.search.tapOnClear(this.tabName);
			this.list = [];
			this.selectionShopArr = [];
			this.notContact = false;
			this.allChecked = false;
		},
		//全选
		checkeAll(e) {
			this.$refs.multiTable.toggleSelection(this.list, e);
		},
		seeNotContact(e) {
			this.params.contact_status = e ? '0' : undefined;
			this.getProductList();
			// this.sampleStatusNum();
			this.sampleStatistical();
		},
		//选择商品
		selectionChange(val) {
			this.selectionShopArr = val;
			if (!this.selectionShopArr.length) {
				this.allChecked = false;
			}
			if (this.list.length <= this.params.page_size) {
				if (this.selectionShopArr.length == this.list.length) {
					this.allChecked = true;
				} else {
					this.allChecked = false;
				}
			} else {
				if (this.selectionShopArr.length == this.params.page_size) {
					this.allChecked = true;
				} else {
					this.allChecked = false;
				}
			}
		},
		//分页
		gePartnerList(val) {
			this.params.page_index = val.page_index;
			this.params.page_size = val.page_size;
			this.getProductList();
		},
		//筛选
		onSubmit(val, noGetTabNum, defaultTimeState, paramsTextObj) {
			this.params = val;
			this.$refs.multiTable.resetPage();
			this.paramsTextObj = paramsTextObj;
			this.params.page_index = 1;
			this.params.page_size = 10;
			const { cooperateId } = this;
			if (cooperateId) this.params.cooperate_id = cooperateId;
			if (val.other_status) {
				this.tabName = val.other_status;
			}
			if (!val.create_time_start && !val.create_time_end && defaultTimeState) {
				const [todayStart, todayEnd] = calDate(0);
				this.params.create_time_start = Math.trunc(startOfDay(subMonths(new Date(), 1)).getTime() / 1000);
				this.params.create_time_end = Date.parse(todayEnd) / 1000;
			}
			this.getProductList();
			this.sampleStatistical();
			if (noGetTabNum) return;
			// this.sampleStatusNum();
		},
		//导出表
		async exprotTable() {
			this.$refs.exportSampleOrderDrawer.show({ ...this.params, platform_id: this.platformId }, this.paramsTextObj);
			// try {
			// 	this.exportLoading = true;
			// 	const { download_url } = await exportSampleList({ ...this.params, platform_id: this.platformId });
			// 	this.exportLoading = false;
			// 	window.open(download_url, '_blank');
			// } catch (error) {
			// 	if (error.code === -1) {
			// 		this.$message.error(error.message);
			// 	}
			// 	this.exportLoading = false;
			// }
		},
		//刷新列表
		refreshList() {
			this.getProductList();
			this.sampleStatistical();
			// this.sampleStatusNum();
		},
		async stopCooperation({ cooperate_id }) {
			try {
				await this.$confirm('停止合作后，该商品的合作信息保留，手动移除商品后才可以再次将该商品加入该达人的选品表。', '停止合作');
				const { code } = await stopCooperation({ cooperate_id });
				if (code !== 0) return;
				this.$message.success('停止合作成功');
				this.refreshList();
			} catch (error) {}
		},
		reCooperation: throttle(async function ({ cooperate_id }) {
			const { code } = await reCooperation({ cooperate_id });
			if (code !== 0) return;
			this.$message.success('操作成功');
			this.refreshList();
		}, 1000),
		showDetailDrawer(anchor_id) {
			this.$refs.detailDrawer.show(anchor_id);
		},
		showLogisticsDetailDrawer(row) {
			this.$refs.logisticsDetailDrawer.show(row, 1);
		},
		batchContact() {
			if (!this.selectionShopArr.length) return;
			let total = this.selectionShopArr.length;
			let filter = this.selectionShopArr.filter(item => item.contact_status === '0');
			let sample_sn = this.selectionShopArr.map(item => item.sample_sn).join(',');
			this.$refs.batch.show(total, filter.length, sample_sn);
		},
		settingRemarks(row) {
			this.$refs.remarks.show(row);
		},
		async getAudit() {
			const { sampleAudit = AUDIT_STATUS_CLOSE } = await getAuditConf({});
			//1开启 2关闭
			this.sampleAudit = sampleAudit;
			if (sampleAudit === AUDIT_STATUS_OPEN) return;
			if (this.tabName === sampleStutas.Audit || this.tabName === sampleStutas.noPass) {
				this.tabName = '0';
				this.$refs.search.setParams(this.tabName);
			}
		},
		batchRefuse() {
			if (!this.selectionShopArr.length) return;
			let sampleSnList = this.selectionShopArr.map(item => item.sample_sn);
			this.$refs.refuseApply.show({ sampleSnList }, 'batch');
		},
		async batchPass() {
			if (!this.selectionShopArr.length) return;
			const sampleSnList = this.selectionShopArr.map(item => item.sample_sn);
			const { fail = [], success = [] } = await batchsampleAuditPass({ sampleSnList });
			this.$modal({
				title: '提示',
				contentTitle: `操作成功 ${success.length} 条，失败 ${fail.length} 条`,
				size: 'small',
				btns: [
					{
						type: 'primary',
						text: '我知道了',
						key: 'confirm',
					},
				],
			}).then(res => {
				if (res.key == 'confirm') {
					res.done();
				} else {
					res.done();
				}
			});
			this.refreshList();
		},
		async batchCancelCollaborate() {
			if (!this.selectionShopArr.length) return;
			const sampleSnList = this.selectionShopArr.map(item => item.sample_sn);
			const { errorCount, successCount } = await batchCancelCooperate({ sampleSnList });
			this.$modal({
				title: '提示',
				contentTitle: `共有 ${successCount} 条同步成功， ${errorCount}条同步失败`,
				size: 'small',
				btns: [
					{
						type: 'primary',
						text: '我知道了',
						key: 'confirm',
					},
				],
			}).then(res => {
				if (res.key == 'confirm') {
					res.done();
				} else {
					res.done();
				}
			});
			this.refreshList();
		},
		async batchSyncCollaborate() {
			if (!this.selectionShopArr.length) return;
			this.$refs.syncCollaborate.show(this.selectionShopArr);
		},
		bindShopSkip() {
			// 商家协作的代码
			let path = '/index/home';
			this.$auth.hasPermi('system:cooperativeShop-query') && (path = '/cooperativeShop/list');
			this.$auth.hasPermi('system:viewRules-query') && (path = '/cooperativeShop/collaborateRules/viewRules');
			const { href } = this.$router.resolve({ path });
			window.open(href, '_blank');
		},
		async getCooperationStatus() {
			const { cooperationStatus = false } = await shopCooperationStatus();
			this.cooperationStatus = cooperationStatus;
		},
	},
};
</script>
<style lang="less" scoped>
.multiTable {
	::v-deep .el-table__row:nth-child(n + 2) td {
		border-top: 12px solid #f5f5f5;
	}
}

.btn-box {
	height: 40px;
	padding-bottom: 10px;
	border-bottom: 1px solid #eee;
	/* background-color: #F5F5F5; */
}

.table-box {
	flex: 1;
}
.bind-icon {
	width: 158px;
	right: 0px;
}
.tab {
	/deep/ .el-icon-loading {
		font-size: 42px;
	}
}
.multiTable {
	/deep/ .el-table__header-wrapper {
		display: none !important;
	}
}
</style>
